// @flow

import styled from "styled-components";

export const SortMenu = styled.span`
  position: relative;
  display: inline-block;
`;
